// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 736 ? "vendor" : chunkId) + ".bundle.js?" + {"736":"a538a5c0715904923fdb","856":"828dabd4f5d54e2b0824","932":"7c223b6e5d1d09d62e53"}[chunkId] + "";
};